// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Card, Typography } from "@mg/dali/src";
// eslint-disable-next-line import/named
import { createRoute, useNavigate } from "@tanstack/react-router";

import { knowledgeSettingRoute } from "./routes/knowledgeSettingRoute";

import { authLayoutRoute } from "../auth-layout/route";

export const settingsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "settings",

  component: Settings,
});

function Settings() {
  const navigate = useNavigate({ from: settingsRoute.to });
  return (
    <article className="grid gap-6 overflow-auto px-10 py-6">
      <header className="flex items-center justify-between">
        <Typography as="h1" size="2xl" weight="bold">
          Settings
        </Typography>
      </header>

      <Card onClick={() => navigate({ to: knowledgeSettingRoute.to })}>
        <Typography>Knowledge Settings</Typography>
      </Card>
    </article>
  );
}
